import { produce } from "immer";
import {
  ADD_STEP,
  ADD_STEP_FAILURE,
  ADD_STEP_SUCCESS,
  //
  DELETE_STEP,
  DELETE_STEP_FAILURE,
  DELETE_STEP_SUCCESS,
  //
  EDIT_STEP,
  EDIT_STEP_FAILURE,
  EDIT_STEP_SUCCESS,
  //
  FETCH_STEPS,
  FETCH_STEPS_FAILURE,
  FETCH_STEPS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_STEP_ADD_MODAL,
  //
  UPDATE_STEP_ORDER,
  UPDATE_STEP_ORDER_SUCCESS,
  UPDATE_STEP_ORDER_FAILURE,
  //
  VALIDATE_DELETE,
  VALIDATE_DELETE_SUCCESS,
  VALIDATE_DELETE_FAILURE,
  //
  TOGGLE_STEP_DELETE_MODAL,
} from "./constants";

export const initialState = {
  isFetchingSteps: false,
  onboardingData: {},
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentStep: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  //
  stepAddModal: {
    open: false,
    isEditing: false,
  },
  isUpdatingStepOrder: false,
  //
  isValidatingDelete: false,
  stepDeleteModal: {
    open: false,
  },
};

const StepReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_STEPS:
        draft.isFetchingSteps = true;
        draft.onboardingData = {};
        break;
      case FETCH_STEPS_SUCCESS:
        draft.isFetchingSteps = false;
        draft.onboardingData = action.payload;
        break;
      case FETCH_STEPS_FAILURE:
        draft.isFetchingSteps = false;
        draft.onboardingData = {};
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentStep = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentStep = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentStep = {};
        break;
      // Add
      case ADD_STEP:
        draft.isSubmitting = true;
        break;
      case ADD_STEP_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_STEP_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_STEP:
        draft.isSubmitting = true;
        break;
      case EDIT_STEP_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_STEP_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_STEP:
        draft.isDeleting = true;
        break;
      case DELETE_STEP_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_STEP_FAILURE:
        draft.isDeleting = false;
        break;
      case TOGGLE_STEP_ADD_MODAL:
        draft.stepAddModal = action.payload;
        break;
      case UPDATE_STEP_ORDER:
        draft.isUpdatingStepOrder = true;
        break;
      case UPDATE_STEP_ORDER_SUCCESS:
        draft.isUpdatingStepOrder = false;
        break;
      case UPDATE_STEP_ORDER_FAILURE:
        draft.isUpdatingStepOrder = false;
        break;

      case VALIDATE_DELETE:
        draft.isValidatingDelete = true;
        break;
      case VALIDATE_DELETE_SUCCESS:
        draft.isValidatingDelete = false;
        break;
      case VALIDATE_DELETE_FAILURE:
        draft.isValidatingDelete = false;
        break;
      case TOGGLE_STEP_DELETE_MODAL:
        draft.stepDeleteModal = action.payload;
        break;
      default:
        return state;
    }
  });

export default StepReducer;
